import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {useConsumerContext} from "../../context/ConsumerContext";
import addressData from "../../data/addressData.json";
import {AVAILABLE_ACTIONS} from "../../utils/constants";
import {Box, Grid, MenuItem, Typography} from "@material-ui/core";
import {MUICardWithControl, MUIInput, MUISelect, MUISwitch} from "../../utils/formUtils";
import * as yup from "yup";
import {ClaimDetails, WizardNav} from "../../utils/fmapUtils";
import PoolOutlinedIcon from '@mui/icons-material/PoolOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import WaterOutlinedIcon from '@mui/icons-material/WaterOutlined';
import FireExtinguisherRoundedIcon from '@mui/icons-material/FireExtinguisherRounded';
import StormRoundedIcon from '@mui/icons-material/StormRounded';

const validationSchema = yup.object().shape({
    numOfClaims: yup.number().required('Please complete all required fields').typeError('Please complete all required fields').notOneOf(['-100', -100], 'Please complete all required fields.'),
    lossType1: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 0,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none', null], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    claimStatus1: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 0,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none', null], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    lossType2: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 1,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    claimStatus2: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 1,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    lossType3: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 2,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    claimStatus3: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 2,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    lossType4: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 3,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    claimStatus4: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 3,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    lossType5: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 4,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    claimStatus5: yup.string().when('numOfClaims', {
        is: (numOfClaims) => numOfClaims > 4,
        then: yup.string().required('Please complete all required fields').nullable().notOneOf(['none'], 'Please complete all required fields'),
        otherwise: yup.string().notRequired().nullable()
    }),
    milesFromSaltWater: yup.string().when('distanceToCoastPrefill', {
        is: (distanceToCoastPrefill) => distanceToCoastPrefill !== 'Y',
        then: yup.string().required('Distance required.').nullable().notOneOf(['-100'], 'Distance required.'),
        otherwise: yup.string().notRequired().nullable()
    })
})
export default function OtherDetails() {
    const {handleSubmit, control, trigger, formState: {errors}} = useForm({resolver: yupResolver(validationSchema)});
    const {consumerData, dispatch} = useConsumerContext();

    // loading static data when component loads
    useEffect(() => {
        // Anything in here is fired on component mount.
        // fetching static data
        setLossTypeList(addressData.lossType);
        setDisToCoastList(addressData.distanceToCoast)
    }, []);

    const [lossTypeList, setLossTypeList] = useState([]);
    const [disToCoastList, setDisToCoastList] = useState([]);

    // updating the state as the user types...
    const handleFormChange = (event) => {
        dispatch({
            type: AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS,
            userRequest: {[event.target.name]: event.target.value}
        });
    };

    const handleFormChangeCheckbox = (event) => {
        dispatch({
            type: AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS,
            userRequest: {[event.target.name]: event.target.checked}
        });
    };

    const onSubmit = (data) => {
        conditionalCheckForClaims(data);
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS, userRequest: data});
        dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep + 1});
    };

    const handleBackClick = async () => {
        conditionalCheckForClaims();
        const isValid = await trigger(['numOfClaims', 'lossType1', 'claimStatus1', 'lossType2', 'claimStatus2', 'lossType3', 'claimStatus3', 'lossType4', 'claimStatus4', 'lossType5', 'claimStatus5']);
        if (isValid) {
            dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep - 1});
        }
    }

    function conditionalCheckForClaims(data) {
        [...Array(6)].map((_, k) => {
            if (k <= consumerData?.numOfClaims) {

            } else {
                let lossT = "lossType" + k;
                let claimsS = "claimStatus" + k;
                if (data) {
                    data[lossT] = "none";
                    data[claimsS] = "none";
                } else {
                    dispatch({type: AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS, userRequest: {lossT: undefined}});
                    dispatch({type: AVAILABLE_ACTIONS.UPDATE_OTHER_DETAILS, userRequest: {claimsS: undefined}});
                }
            }
        });

    }

    return (
        <section>
            <Box m={2} marginBottom={0}>
                <Typography variant="h4" align="left" component="h4" gutterBottom
                            style={{paddingLeft: 24, fontWeight: 600}}>
                    Other Details
                </Typography>
            </Box>
            <form
                onSubmit={handleSubmit(onSubmit)}>
                <Box m={3} marginTop={0}>
                    <Grid container alignItems="flex-start" spacing={2} style={{paddingLeft: 8, paddingTop: 8}}>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUICardWithControl label="Do you have a pool?" children={
                                <MUISwitch errors={errors}
                                           defaultValue={consumerData?.hasOnsitePool}
                                           value={consumerData?.hasOnsitePool} name="hasOnsitePool"
                                           control={control} onChecked={handleFormChangeCheckbox}></MUISwitch>
                            } icon={<PoolOutlinedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <MUICardWithControl label="Is the property located within 1000 ft. of a fire hydrant?"
                                                children={
                                                    <MUISwitch errors={errors}
                                                               defaultValue={consumerData?.isLocated1000ftFireHydrant}
                                                               value={consumerData?.isLocated1000ftFireHydrant}
                                                               name="isLocated1000ftFireHydrant"
                                                               control={control} onChecked={handleFormChangeCheckbox}/>
                                                } icon={<FireExtinguisherRoundedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                            <div style={{display: "none"}}>
                                <MUIInput control={control} name="distanceToCoastPrefill" inputPrp={{maxLength: 200}}
                                          defaultValue={consumerData?.distanceToCoastPrefill}
                                          value={consumerData?.distanceToCoastPrefill}
                                          onInputChange={handleFormChange} errors={errors}/>
                            </div>
                        </Grid>
                        {consumerData?.fireStationPrefill !== 'Y' && <Grid item xs={12} sm={6} md={4}>
                            <MUICardWithControl
                                label="Is the property located within five miles of a manned fire station?"
                                children={
                                    <MUISwitch errors={errors}
                                               defaultValue={consumerData?.is5miFromMannedFireStation}
                                               value={consumerData?.is5miFromMannedFireStation}
                                               name="is5miFromMannedFireStation"
                                               control={control} onChecked={handleFormChangeCheckbox}/>
                                } icon={<LocalFireDepartmentOutlinedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>}
                        {consumerData?.distanceToCoastPrefill !== 'Y' &&
                        <Grid item xs={12} sm={6} md={4}>
                            <MUICardWithControl
                                label="What is the property’s distance to salt water? (e.g., ocean intercoastal)"
                                children={
                                    <MUISelect id="milesFromSaltWater" control={control} name="milesFromSaltWater"
                                               errors={errors}
                                               defaultValue={consumerData?.milesFromSaltWater}
                                               value={consumerData?.milesFromSaltWater} onFormChange={handleFormChange}
                                               errors={errors}>
                                        <MenuItem key="none" value="-100" disabled>--Select--</MenuItem>
                                        {disToCoastList.map(type => {
                                            return <MenuItem key={type?.value}
                                                             value={type?.value}>{type?.label}</MenuItem>
                                        })}
                                    </MUISelect>
                                } icon={<WaterOutlinedIcon style={{
                                backgroundColor: '#3f51b5',
                                padding: 16,
                                fontSize: 16,
                                height: 64,
                                width: 64,
                                marginBottom: 16,
                                color: '#ffffff',
                                borderRadius: 20
                            }}/>}/>
                        </Grid>}
                        <Grid item xs={12} sm={6} md={4}>
                            <MUICardWithControl label="Number of property claims you have filed in the last three years"
                                                children={
                                                    <MUISelect id="numOfClaims" control={control} name="numOfClaims"
                                                               errors={errors}
                                                               defaultValue={consumerData?.numOfClaims}
                                                               value={consumerData?.numOfClaims}
                                                               onFormChange={handleFormChange}>
                                                        <MenuItem key="none" value="-100" disabled>--Select--</MenuItem>
                                                        {[...Array(6)].map((_, k) => {
                                                            return <MenuItem key={k} value={k}>{k}</MenuItem>
                                                        })}
                                                        <MenuItem key="100" value="100">More than 5</MenuItem>
                                                    </MUISelect>
                                                }
                                                icon={<StormRoundedIcon style={{
                                                    backgroundColor: '#3f51b5',
                                                    padding: 16,
                                                    fontSize: 16,
                                                    height: 64,
                                                    width: 64,
                                                    marginBottom: 16,
                                                    color: '#ffffff',
                                                    borderRadius: 20
                                                }}/>}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}></Grid>
                        {consumerData?.fireStationPrefill === 'Y' && <Grid item xs={12} sm={6} md={4}></Grid>}
                        {consumerData?.distanceToCoastPrefill === 'Y' && <Grid item xs={12} sm={6} md={4}></Grid>}
                        {[...Array(5)].map((_, k) => {
                            let val = k + 1;
                            if (val <= consumerData?.numOfClaims) {
                                let lossT = "lossType" + val;
                                let claimsS = "claimStatus" + val;
                                let claimL = "Claim " + val;
                                return <ClaimDetails errors={errors} controlObject={control} lossTypeName={lossT}
                                                     lossTypeLabel="Claim Type Description"
                                                     lossTypeValue={consumerData[lossT] === null ? "none" : consumerData[lossT]}
                                                     lossTypeDefaultValue={consumerData[lossT] === null ? "none" : consumerData[lossT]}
                                                     claimStatusName={claimsS} claimStatusLabel="Claim Status"
                                                     claimLabel={claimL}
                                                     claimStatusValue={consumerData[claimsS] === null ? "none" : consumerData[claimsS]}
                                                     claimStatusDefaultValue={consumerData[claimsS] === null ? "none" : consumerData[claimsS]}
                                                     handleFormChange={handleFormChange}/>
                            }
                        })}

                    </Grid>
                </Box>
                <WizardNav handleBackClick={handleBackClick} currentStep={consumerData?.wizardStep}/>
            </form>

        </section>
    );
}
